<template>
  <div class="percent-bar">
    <div
      v-if="label"
      class="percent-bar__label"
    >
      <div class="percent-bar__label__text">
        {{ label }}
      </div>

      <div
        v-if="!hidePercentage"
        class="percent-bar__label__percentage"
      >
        {{ dataset | percentage }}
      </div>
    </div>

    <div class="percent-bar__bar">
      <div class="percent-bar__bar__thumb">
        <div
          :style="progressStyle"
          class="percent-bar__bar__thumb__track"
        />
      </div>

      <div
        v-if="!hidePercentage && !label"
        class="percent-bar__bar__percentage"
      >
        {{ dataset | percentage }}
      </div>
    </div>
  </div>
</template>

<script>
import { percentageFilter } from '@/utils/filters'

export default {
  name: 'BasePercentBar',

  filters: {
    percentage: percentageFilter
  },

  props: {
    dataset: {
      type: Number,
      default: 0
    },
    hidePercentage: Boolean,
    label: String,
    progressColor: {
      type: String,
      default: '#98c1dd'
    },
  },

  computed: {
    progressStyle () {
      return {
        '--progress-track-color': `${this.progressColor}`,
        '--progress-track-width': `${this.dataset}%`
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.percent-bar {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  line-height: 130%;

  &__label {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 10px;
    margin-bottom: 5px;

    &__percentage {
      flex: 0 0 52px;
      font-weight: 700;
      text-align: right;
    }
  }

  &__bar {
    display: flex;
    align-items: center;
    gap: 10px;

    &__thumb {
      flex-grow: 1;
      height: 8px;
      border-radius: 2em;
      background: nth($colors-custom, 4);

      &__track {
        width: var(--progress-track-width);
        height: 100%;
        border-radius: 2em;
        background: var(--progress-track-color);
      }
    }

    &__percentage {
      font-weight: 700;
      text-align: right;
    }
  }
}
</style>
